import React from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import FilterOutlinedIcon from '@mui/icons-material/FilterOutlined';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import WavesOutlinedIcon from '@mui/icons-material/WavesOutlined';
import VpnKeyIcon from '@mui/icons-material/VpnKey'; // this is slightly off
import {
  AgricultureOutlined,
  ApartmentOutlined,
  AssignmentOutlined,
  BusinessCenterOutlined,
  BusinessOutlined,
  GrassOutlined,
  HolidayVillageOutlined,
  Language,
  VillaOutlined,
} from '@mui/icons-material';
import { HandshakeOutlined } from '@mui/icons-material';
import { LocationOnOutlined } from '@mui/icons-material';

export const EditNavigationIcons = ({ groupName }: { groupName: string }) => {
  switch (groupName) {
    case 'Listing Details':
      return <DescriptionOutlinedIcon />;
    case 'Transaction Participants':
      return <GroupOutlinedIcon />;
    case 'Listing Agreement':
      return <HandshakeOutlined />;
    case 'Media Center':
      return <FilterOutlinedIcon />;
    case 'Location':
      return <LocationOnOutlined />;
    case 'Association/Community':
      return <HolidayVillageOutlined />;
    case 'Taxes':
      return <RequestQuoteOutlinedIcon />;
    case 'Building and Utilities':
      return <HandymanOutlinedIcon />;
    case 'Features and Rooms':
      return <BedOutlinedIcon />;
    case 'Lot and Parking':
      return <DriveEtaOutlinedIcon />;
    case 'Water/Shore':
      return <WavesOutlinedIcon />;
    case 'Remarks and Internet Settings':
      return <Language />;
    case 'Showing':
      return <VpnKeyIcon />;
    case 'Commercial Sale Details':
      return <BusinessOutlined />;
    case 'Multi-Family Details':
      return <VillaOutlined />;
    case 'Open Houses':
      return <MeetingRoomOutlinedIcon />;
    case 'Commercial Lease Details':
      return <ApartmentOutlined />;
    case 'Business Opportunity':
      return <BusinessCenterOutlined />;
    case 'Farm Details':
      return <AgricultureOutlined />;
    case 'Land Details':
      return <GrassOutlined />;
    case 'Lease Details':
      return <AssignmentOutlined />;
    default:
      return <DescriptionOutlinedIcon />;
  }
};
